import React from 'react'
import './reportsCard.css'
import { useSelector } from 'react-redux'

const ReportsCard = () => {
    const {user} = useSelector((state)=> state.user)

    const today = new Date()
    const currentMonth = today.getMonth() + 1
    const currentYear = today.getFullYear()

    const filterReport = user?.reports?.filter((item)=> {
        return String(item?.month) === String(currentMonth) && String(item?.year) === String(currentYear)
    })

  return (
    <div className='reports__card'>
        <h4 className="task__card-title">
            Reports
        </h4>

        <div className="reports__card-list">
            <div className="reports__card-item">
                <h4 className="reports__card-count">
                    {filterReport?.map((item)=>item?.totalSubmitted) || 0}
                </h4>
                <span className="reports__card-name">Submitted this Month</span>
            </div>
            <div className="reports__card-item">
                <h4 className="reports__card-count">
                    {filterReport?.map((item)=>item?.totalMissed) || 0}
                </h4>
                <span className="reports__card-name">Missed this Month</span>
            </div>
        </div>
    </div>
  )
}

export default ReportsCard